import classNames from 'classnames'
import type { FunctionComponent } from 'react'

import styles from './review-carousel.module.scss'
import { ReviewCard } from './ReviewCard'
import { Text } from '../../components/text'
import type { ReviewSectionFragment } from '../../graphql/fragments/ReviewSectionFragment.graphql'

export const ReviewCarousel: FunctionComponent<ReviewCarouselProps> = ({
    reviews,
    disclaimerCopy,
}) => {
    return (
        <div className={styles.container}>
            <div className={styles['overflow-hidden']}>
                <div className={styles['scroll-row']}>
                    {reviews?.items.map((item, index) => (
                        <ReviewCard
                            index={index}
                            key={index}
                            title={item?.title}
                            titleColor={item?.titleColor}
                            titleSizeDesktop={item?.titleSizeDesktop}
                            titleSizeMobile={item?.titleSizeMobile}
                            text={item?.text}
                            textColor={item.textColor}
                            textSizeDesktop={item.textSizeDesktop}
                            textSizeMobile={item.textSizeMobile}
                            author={item?.author}
                            authorSize={item?.authorSize}
                            rating={item.rating}
                            ratingColor={item.starRatingColor}
                            backgroundColor={item.backgroundColor}
                            className={classNames(
                                classNames(styles.card, styles['review-card']),
                            )}
                        />
                    ))}
                </div>
            </div>

            <div className={styles['review-disclaimer']}>
                <Text typeStyle='body-xs' tag='p' color='dim'>
                    {disclaimerCopy}
                </Text>
            </div>
        </div>
    )
}

export default ReviewCarousel

export type ReviewCarouselProps = Omit<ReviewSectionFragment, 'sys' | 'type'>
